export default __webpack_public_path__ + "static/media/Morgan_9781408309094.8080de4f.jpg";